// store/chatStore.ts
import { create } from 'zustand';
import {
  Message,
  User as UserData,
  CharacterPayload,
} from '@client/components';

interface ChatStore {
  messages: Message[];
  setMessages: (messages: Message[] | ((prev: Message[]) => Message[])) => void;

  userInputQueue: Message[];
  enqueueUserMessage: (message: Message) => void;
  dequeueUserMessage: () => Message | undefined;

  user: UserData | null;
  setUser: (user: UserData) => void;

  character: CharacterPayload | null;
  setCharacter: (char: CharacterPayload) => void;

  isGenerating: boolean;
  setIsGenerating: (val: boolean) => void;

  resetChat: () => void;
}

export const useChatStore = create<ChatStore>((set, get) => ({
  messages: [],
  setMessages: (updater) =>
    set((state) => ({
      messages:
        typeof updater === 'function' ? updater(state.messages) : updater,
    })),

  userInputQueue: [],
  enqueueUserMessage: (message: Message) =>
    set((state) => ({ userInputQueue: [...state.userInputQueue, message] })),
  dequeueUserMessage: () => {
    const queue = get().userInputQueue;
    if (!queue.length) return undefined;
    const next = queue[0];
    set({ userInputQueue: queue.slice(1) });
    return next;
  },

  user: null,
  setUser: (user: UserData) => set({ user }),

  character: null,
  setCharacter: (char: CharacterPayload) => set({ character: char }),

  isGenerating: false,
  setIsGenerating: (val: boolean) => set({ isGenerating: val }),

  resetChat: () =>
    set({
      messages: [],
      userInputQueue: [],
      character: null,
      isGenerating: false,
    }),
}));